module.exports = __webpack_public_path__ + "img/lock_bottom_box2.cb9fbdb8.png";